import React from "react";
import { Box, Container, Link, Typography } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        py: 1, // Padding top and bottom
        mt: "auto", // Push footer to bottom of content
        mb: "32px", // Margin bottom für StatusBar (32px Höhe)
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Left side with copyright */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CopyrightIcon fontSize="small" />
            <Typography variant="body2">
              {new Date().getFullYear()} EHC Kundl
            </Typography>
          </Box>

          {/* Right side with links */}
          <Box sx={{ display: "flex", gap: 2 }}>
            <Link
              href="https://www.ehckundl.at/impressum/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "primary.contrastText",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Typography variant="body2">Impressum</Typography>
            </Link>
            <Link
              href="https://www.ehckundl.at/datenschutz/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "primary.contrastText",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              <Typography variant="body2">Datenschutz</Typography>
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
